import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import axios from './services'
import store from './store'
import vuetify from './plugins/vuetify'
import formComponents from './components/index.js'
import AsyncComputed from 'vue-async-computed'
import DatetimePicker from 'vuetify-datetime-picker'
import VueTour from 'vue-tour'

import './plugins/clipboard'
import './plugins/cookies'
import './plugins/datetimepicker'
import './plugins/katex'
import './plugins/notifications'

require('vue-tour/dist/vue-tour.css')

Vue.config.productionTip = false
Vue.use(formComponents)
Vue.use(AsyncComputed)
Vue.use(DatetimePicker) // TODO we might be able to remove this one and only use the custom one
Vue.use(VueTour)

new Vue({
  vuetify,
  router,
  axios,
  store,
  formComponents,
  render: (h) => h(App)
}).$mount('#app')

window.onload = function () {
  delete localStorage.history
}
